<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-4">{{ $t("transactions") }}</div>
      <div class="mt-3 mb-4">
        <div class="row">
          <!-- SELECT DROPDOWN -->
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="
                  selectedCinema && selectedCinema.length > 0 ? 'shift-up' : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedCinema"
                name="selectcinema"
                id="selectcinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    :placeholder="$tc('searchCinema')"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema($event.target.value)"
                    v-on:keydown="onSearchCinema($event.target.value)"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  href="#"
                  v-for="(Cinema, CinemaIndex) in Cinemas"
                  :key="CinemaIndex"
                  v-on:click="onSelectCinema($event, Cinema)"
                  >{{ Cinema.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  v-if="fetchTransactionDetail.date"
                  v-on:click="clearDate()"
                  class="btn-clearDate"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="fetchTransactionDetail.date"
                  name="selectenddate_1"
                  id="selectenddate_1"
                  v-validate="'required'"
                  :typeable="true"
                  @input="onchangeDate()"
                ></Datepicker>
                <label :class="fetchTransactionDetail.date ? 'active' : ''">{{
                  $t("date")
                }}</label>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <!-- <button v-if="selectedFilter" v-on:click="clearFilter()" class="btn-clearDate">✖</button> -->
              <label
                :class="
                  selectedFilter && selectedFilter.length > 0 ? 'shift-up' : ''
                "
                >{{ $t("select") }} {{ $tc("filter") }}</label
              >
              <b-dropdown
                :text="selectedFilter"
                name="selectuser"
                id="selectcinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  href="#"
                  v-for="(User, UserIndex) in users"
                  :key="UserIndex"
                  v-on:click="onSelectFilter($event, User)"
                  >{{ User }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>

          <div
            v-if="
              selectedFilter &&
                selectedFilter.length > 0 &&
                selectedFilter != 'Show Booking Code' &&
                selectedFilter != 'User'
            "
            class="col-lg-4 col-xl-3 align-self-center mb-4"
          >
            <div class="dropdown-curve-container mr-2">
              <label
                :class="
                  selectedFilterValue && selectedFilterValue.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ selectedFilter }}</label
              >
              <b-dropdown
                :text="selectedFilterValue"
                name="selectuser"
                id="selectcinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    :placeholder="$tc('searchFilters')"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchFilterValues()"
                    v-on:keydown="onSearchFilterValues()"
                    v-model="searchFilterValues"
                  />
                </div>
                <b-dropdown-item
                  href="#"
                  v-for="(value, valueIndex) in filterValues"
                  :key="valueIndex"
                  v-on:click="onSelectFilterValue(value)"
                  >{{
                    value.username
                      ? value.username
                      : value.movie
                      ? value.movie
                      : value.screen_name
                  }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
          <div
            v-if="selectedFilter == 'Show Booking Code'"
            class="col-lg-4 col-xl-3 align-self-center mb-4"
          >
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  placeholder="."
                  type="text"
                  v-model="filtervalue"
                  name="firstname"
                  id="firstname"
                />
                <label>{{ $t("showBookingCode") }}</label>
              </div>
            </div>
          </div>
          <div
            v-if="selectedFilter == 'User'"
            class="col-lg-4 col-xl-3 align-self-center mb-4"
          >
            <multiselect
              v-model="searchUserValue"
              label="username"
              track-by="user_id"
              :placeholder="$tc('typeToSearchUser')"
              open-direction="bottom"
              :options="searchUsers"
              :multiple="false"
              :options-limit="50"
              :max-height="600"
              :loading="isSearchLoading"
              @select="onSelectFilterValue($event)"
              @search-change="onAsyncSearchUser"
            >
              <span slot="noResult">Oops! No Results found.</span>
            </multiselect>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <button
              :disabled="btenable"
              @click.prevent.stop="onGetTransactionList"
              class="btn-blue-lg w-100"
            >
              {{ $tc("fetch") }} {{ $t("report") }}
            </button>
          </div>
        </div>
      </div>

      <div class="swc-report">
        <table class="swc-report-table" border="1">
          <thead>
            <tr>
              <th>{{ $t("booking") }} {{ $t("user") }}</th>
              <th>{{ $t("customer") }} {{ $t("name") }}</th>
              <th>{{ $t("customer") }} {{ $t("phone") }}</th>
              <th>{{ $t("transaction") }} {{ $t("booking") }} {{ $t("date") }} & {{ $t("time") }}</th>
              <th>{{ $t("show") }} {{ $t("booking") }} {{ $t("code") }}</th>
              <th>{{ $t("screen") }} {{ $t("name") }}</th>
              <th>{{ $t("film") }} {{ $t("name") }}</th>
              <th>{{ $t("show") }} {{ $t("date") }} & {{ $t("time") }}</th>
              <th>{{ $t("seats") }}</th>

              <th>{{ $t("amounts") }}</th>

              <th>{{ $t("offer") }} | {{ $t("voucher") }}</th>
            </tr>
          </thead>
          <tbody
            v-for="(user, userIndex) in transactionList"
            :key="userIndex"
            class="sph-report"
          >
            <tr>
              <td>{{ user.booking_user_name }}</td>
              <td>{{ user.customer_name | filterNullUndefined }}</td>
              <td>{{ user.customer_mobile | filterNullUndefined }}</td>
              <td>{{ user.t_booking_date_time | fulldatemonparse }}</td>
              <td>{{ user.sb_booking_code }}</td>
              <td>{{ user.screen_name }}</td>
              <td>{{ user.film_name }}</td>
              <td>{{ user.t_show_date | dateparse }} {{ user.t_show_time }}</td>
              <td>{{ user.seats }}</td>

              <td>{{ user.total_amount.toFixed(this.MIN_FRACTION_DIGITS) }}</td>
              <td>
                {{
                  user.offer_name
                    ? user.offer_name
                    : user.voucher_name
                    ? user.voucher_name
                    : "-"
                }}
              </td>
            </tr>
          </tbody>
          <tbody v-if="transactionList.length == 0">
            <tr>
              <td colspan="11">
                <!-- <h3  class="ml-3">
                  {{ "No records found" }}
                </h3> -->
                <NoRecords/>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import CinemasService from "@/services/CinemasService";
import UserService from "@/services/UserService";
import MovieService from "@/services/MovieService";
import MasterService from "@/services/MasterService";
import SetupService from "@/services/SetupService";
import moment from "moment-timezone";
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";
import _ from "lodash";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: { DatePicker, Multiselect, NoRecords },
  data() {
    return {
      CinemasCopy: [],
      searchCinema: "",
      btenable: false,
      selectedFilterValue: "",
      filterValues: [],
      filterValuesCopy: [],
      searchFilterValues: "",
      selectedFilter: "",
      isRoleID: true,
      transactionList: [],
      transactionListCopy: [],
      searchUserValue: "",
      searchUsers: [],
      isSearchLoading: false,

      selectedFilter: "",
      users: ["Screen", "Movie", "User", "Show Booking Code"],
      fetchTransactionDetail: {
        date: "",
        cinema_id: null,
        ssb_code: ""
      },
      selectedCinema: "",
      Cinemas: []
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
      this.getCinemaList(obj);
    } else {
      this.getCinemaList(obj);
    }

    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.onSelectCinema(null, CinemaObj);
    }
  },
  watch: {
    "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
      if (CinemaObj) {
        this.onSelectCinema(null, CinemaObj);
      }
    }
  },
  methods: {
    clearDate() {
      this.fetchTransactionDetail.date = "";
    },
    onchangeDate: _.debounce(function(query) {
      this.onGetTransactionList();
    }, 1.5 * 1000),
    onSearchFilterValues: function() {
      if (this.searchFilterValues && this.searchFilterValues.length > 0) {
        this.filterValues = this.filterValuesCopy.filter(x => {
          // let full_name = `${x.first_name} ${x.last_name}`
          if (
            (x.username &&
              x.username
                .toLowerCase()
                .includes(this.searchFilterValues.toLowerCase())) ||
            (x.movie &&
              x.movie
                .toLowerCase()
                .includes(this.searchFilterValues.toLowerCase())) ||
            (x.screen_name &&
              x.screen_name
                .toLowerCase()
                .includes(this.searchFilterValues.toLowerCase()))
            // x.last_name.toLowerCase().includes(this.searchUser.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.filterValues = this.filterValuesCopy;
      }
    },
    onSearchCinema: function(value) {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter(x => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    onSelectDetails: function(User) {
      this.$router.push({
        path: "/user-management/view-user-audit-log",
        query: {
          user_id: User.user_id,
          login_time: User.login_date_time,
          logout_time: User.logout_date_time,
          date: this.fetchTransactionDetail.date
        }
      });
    },

    getCinemaList: function(cine_id) {
      this.Cinemas = [];
      // let payload = {
      //   tableName: "ms_cinemas",
      //   cine_is_active: "Y"
      // };
      MasterService.GetCinemas({ cine_id: cine_id })
        .then(response => {
          const { data } = response;
          if (data.status && data.Records && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map(x => {
              if (String(cine_id) === String(x.cine_id)) {
                // this.fetchTransactionDetail.cinema_id = x.cine_id;
                // this.selectedCinema = x.cine_name;
                this.onSelectCinema(null, {
                  cine_name: x.cine_name,
                  cine_id: x.cine_id
                });
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectFilter: function(event, params) {
      console.log("params :", params == "Show Booking Code");

      this.filterValues = [];
      this.filterValuesCopy = [];
      this.filtervalue = "";
      this.selectedFilterValue = "";
      this.selectedFilter = params;
      if (params == "User") {
        this.filterkey = "t.created_by";
        // this.getUserList(this.fetchTransactionDetail.cinema_id);
      } else if (params == "Screen") {
        this.filterkey = "screen_name";
        this.getScreens(this.fetchTransactionDetail.cinema_id);
      } else if (params == "Movie") {
        this.filterkey = "md_id";
        this.getMoviesList();
      } else if (params == "Show Booking Code") {
        this.filterkey = "sb_booking_code";
        console.log(" this.filterkey :", this.filterkey);
      }

      //   this.onGetTransactionList();
    },
    getMoviesList: function() {
      this.Movies = [];
      MovieService.GetActiveMoviesWithFormat()
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.filterValues = data.Records;
            this.filterValuesCopy = data.Records;
          } else {
            // Show Error Message
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          console.log("Catch On GetActiveCinemas :", error);
        });
    },
    getScreens: function(cinema_id) {
      let payload = {
        tableName: "screens",
        screen_is_active: "Y",
        cinema_id: cinema_id
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.filterValues = data.Records;
            this.filterValuesCopy = data.Records;
          } else {
            // Shoe Error Message:
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          // Catch Error:
          this.$toasted.show(
            "Catch Error on getActiveScreenByCinemaId :",
            error
          );
        });
    },
    onSelectFilterValue: function(params) {
      if (this.selectedFilter == "User") {
        this.selectedFilterValue = params.username;
        this.filtervalue = params.user_id;
      } else if (this.selectedFilter == "Screen") {
        this.selectedFilterValue = params.screen_name;

        this.filtervalue = params.screen_name;
      } else if (this.selectedFilter == "Movie") {
        this.selectedFilterValue = params.movie;

        this.filtervalue = params.md_id;
      }
      this.searchFilterValues = "";
      this.onSearchFilterValues();
    },
    onGetTransactionList: function() {
      this.transactionList = [];
      if (
        this.fetchTransactionDetail.cinema_id &&
        this.fetchTransactionDetail.date
      ) {
        if (
          this.filterkey &&
          this.filterkey.length > 0 &&
          this.filtervalue.length == 0
        ) {
          this.$toasted.show("Please select or enter filter value.");
        } else {
          let loader = this.$loading.show();

          this.btenable = true;
          let payload = {
            cinema_id: this.fetchTransactionDetail.cinema_id,
            transaction_date: moment(this.fetchTransactionDetail.date).format(
              "YYYY-MM-DD"
            ),
            filterkey: this.filterkey ? this.filterkey : null,
            filtervalue: this.filtervalue ? this.filtervalue : null,
            isMyCinema: true
          };
          MasterService.getTransactionsByDetail(payload)
            .then(response => {
              this.btenable = false;
              const { data } = response;
              if (data.status && data.Records && data.Records.length > 0) {
                this.transactionList = data.Records;
              
                this.transactionListCopy = data.Records;
              } else if (data.Records && data.Records.length == 0) {
                this.$toasted.show("No Records Found.");
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError)
            .finally(() => {
              setTimeout(() => loader.hide(), 1000);
            });
        }
      } else {
        this.$toasted.show("Please select cinema and date");
      }
    },
    onAsyncSearchUser: _.debounce(function(query) {
      if (query) {
        this.isSearchLoading = true;
        this.searchUserValue = query;
        this.searchUsers = [];
        this.getUserList(this.fetchTransactionDetail.cinema_id);
      }
    }, 1 * 1000),
    clearFilter: function() {
      this.selectedFilterValue = "";
      this.filterValues = [];
      this.filterValuesCopy = [];
      this.selectedFilter = "";
      this.selectedFilterValue = "";
      this.filterkey = "";
      this.filtervalue = "";
    },
    onSelectCinema: function(event, params) {
      this.searchCinema = "";
      this.onSearchCinema(null);
      this.selectedCinema = params.cine_name;
      this.fetchTransactionDetail.cinema_id = params.cine_id;
      this.$store.dispatch("selectDropdownCinema", params);
      // this.getUserList(params.cine_id);
      if (this.fetchTransactionDetail.date) {
        this.onGetTransactionList();
      } else {
        this.$toasted.show("Please select date");
      }
    },
    getUserList: function(cinema_Id) {
      this.searchUsers = [];
      let body = {
        limit: null,
        currentPage: null,
        orderby: null,
        columnName: null,
        searchValue: this.searchUserValue
      };
      UserService.ListAllUser({}, body)
        .then(response => {
          const { data } = response;
          if (data.status) {
            this.filterValues = data.data.filter(x => {
              if (x.cinema_id == cinema_Id) {
                return x;
              }
            });
            this.filterValuesCopy = data.data.filter(x => {
              if (x.cinema_id == cinema_Id) {
                return x;
              }
            });
            this.searchUsers = data.data.filter(x => {
              if (x.cinema_id == cinema_Id) {
                return x;
              }
            });
          } else if (
            data.status == false &&
            data.message == "You are not authorized"
          ) {
            this.$router.push({
              path: "/access-denied"
            });
          } else {
            this.$toasted.show(data.message);
          }
          console.log("this.users :", this.users);
        })
        .catch(this._CatchError)
        .finally(() => {
          this.isSearchLoading = false;
        });
    }
  }
};
</script>

<style scoped>
.sph-report th,
td {
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/MyCinemas/Reports/transactionsReports.vue